<div class="modal-header">
    <h2 mat-dialog-title trans>Dns Settings</h2>
    <button type="button" (click)="close()" class="close-button no-style">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>

  <mat-card>
    <mat-card-header>
      <mat-card-title>s3 url:</mat-card-title>
      <mat-card-subtitle>
        <a [href]="dnsPopupService.getUrl('index.html')" target="_blank">
          {{dnsPopupService.getUrl('index.html')}}
        </a>
      </mat-card-subtitle>
      <mat-card-title>ip address:</mat-card-title>
      <mat-card-subtitle>
        192.168.0.114
      </mat-card-subtitle>
      <mat-card-title>name server 1:</mat-card-title>
      <mat-card-subtitle>
        server 1
      </mat-card-subtitle>
      <mat-card-title>name server 2:</mat-card-title>
      <mat-card-subtitle>
        server 2
      </mat-card-subtitle>
    </mat-card-header>
    
  </mat-card>
  <br>
  
  